import React from 'react';
import { Header } from '../../../components/feature/Header';
import { Footer } from '../../../components/feature/Footer';
import { GardenApartmentsHero } from './components/GardenApartmentsHero';
import { WhatAreGardenApartments } from './components/WhatAreGardenApartments';
import { WhyWeSpecialize } from './components/WhyWeSpecialize';
import { CommonChallenges } from './components/CommonChallenges';
import { OurPurchaseProcess } from './components/OurPurchaseProcess';
import { PropertyTypesWeBuy } from './components/PropertyTypesWeBuy';
import { MarketInsights } from './components/MarketInsights';
import { SellerBenefits } from './components/SellerBenefits';
import { WhyChooseUs } from './components/WhyChooseUs';
import { CaseStudies } from './components/CaseStudies';
import { GardenApartmentsFAQ } from './components/GardenApartmentsFAQ';
import { GetOfferSection } from './components/GetOfferSection';
import { FinalCTA } from './components/FinalCTA';

export default function GardenApartmentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <GardenApartmentsHero />
        <WhatAreGardenApartments />
        <WhyWeSpecialize />
        <CommonChallenges />
        <PropertyTypesWeBuy />
        <SellerBenefits />
        <MarketInsights />
        <OurPurchaseProcess />
        <WhyChooseUs />
        <CaseStudies />
        <GardenApartmentsFAQ />
        <GetOfferSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}